import { IS_USE_PLEX_API } from '../../../constants';
import { CasinoTypeUnion } from '../../../types';
import { useGamesStore } from '../../store';

export const useCategory = (
  categoryId: string,
  feedName: string,
  casinoType?: CasinoTypeUnion
) => {
  return useGamesStore((store) =>
    IS_USE_PLEX_API && casinoType
      ? store.lobbies[casinoType]?.categories?.data?.[categoryId]
      : store.feeds[feedName]?.categories?.data?.[categoryId]
  );
};
